import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
import ElementsCustomFieldsForm from './ElementsCustomFieldsForm';
import Validated from 'components/util/Validated';

import { createRoute } from 'lib/util';

const EmployeeForm = ({
  company,
  errors,
  handleAddYear,
  handleRemoveYear,
  handleSubmit,
  handleAddCustomField,
  handleRemoveCustomField,
  handleValueChange,
  handleDependentChange,
  isSaving,
  isSubmitted,
  subcompany,
  t,
  values,
  customs,
}) => {
  // ['Numerico', 'Moneda', "Fecha", "Texto Corto", "Texto Largo", "Drop Dawn", "Seleccion Unica", "Seleccion Multiple", "Hora"]
  // console.table(customs)
  // console.table(values)
  let dropDowns = []; // Para mostrar los drop downs si es que tienen dependencias.
  let depSelect = values.dependent;
  const setOnlyDropDowns = (idValue) => {
    //Generea solamente los drop down sin contar al drop down que es editado
    dropDowns = [];
    customs.forEach((custom) => {
      if (
        (custom.type == 'Drop Dawn' || custom.type == 'Seleccion Multiple') &&
        custom.id != idValue
      ) {
        dropDowns.push(custom);
      }
    });
    // console.table(dropDowns);
  };
  setOnlyDropDowns(values.id);

  const textoUnico = () => {
    if (values.unique) return 'Todos unicos';
    else return 'Unicos personalizados';
  };

  const getIdDependent = (dependent) => {
    //Obtener el id del custom dependeinte
    if (dependent == undefined || dependent._id == undefined) return null;
    dropDowns.some((drop) => {
      if (drop._id == dependent._id) {
        return (depSelect = drop);
      }
    });
    return dependent._id;
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <div className="col-md-12 mt-3">
        <div className="row align-items-center">
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.key) || {}}
              name={'key'}
              label={t('custom_fields_employees.fields.key')}
              handleChange={handleValueChange}
              t={t}
              value={values.key}
            />
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.description) || {}}
              name={'description'}
              label={t('custom_fields_employees.fields.description')}
              handleChange={handleValueChange}
              t={t}
              value={values.description}
            />
          </div>

          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.name) || {}}
              name={'name'}
              label={t('custom_fields_employees.fields.name')}
              handleChange={handleValueChange}
              t={t}
              value={values.name}
            />
          </div>
          {/* Tipo custom field */}
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldSelect
              autoFocus={true}
              label={t('custom_fields_employees.fields.type')}
              name="type"
              handleChange={handleValueChange}
              // handleChange={(e) => { this.props.handleHeaderChange(values, e) }}
              value={values.type}
              noEmptyOption={true}
            >
              <option value="Numerico">{t('custom_fields_employees.add.numeric')}</option>
              <option value="Moneda">{t('custom_fields_employees.add.coin')}</option>
              <option value="Fecha">{t('custom_fields_employees.add.date')}</option>
              <option value="Texto Corto">{t('custom_fields_employees.add.shortText')}</option>
              <option value="Texto Largo">{t('custom_fields_employees.add.largeText')}</option>
              <option value="Drop Dawn">{t('custom_fields_employees.add.dropDown')}</option>{' '}
              {/* Corregir Drop Down */}
              <option value="Seleccion Unica">
                {t('custom_fields_employees.add.uniqueSelection')}
              </option>
              <option value="Seleccion Multiple">
                {t('custom_fields_employees.add.multipleSelection')}
              </option>
              <option value="Hora">{t('custom_fields_employees.add.hour')}</option>
            </Form.FieldSelect>
          </div>
          {/* Tipo custom field */}

          {/* 
          "state_dependent": true,
          "dependent":{ "_id": "5ed646ff08ba91171ac3d13f"},
        */}

          {/* Drop Down */}
          {values.type == 'Drop Dawn' || values.type == 'Seleccion Multiple' ? ( // Corregir Drop Down
            <div>
              <Form.Checkbox
                className="icheckbox_flat-blue"
                // className="text-left input-table"
                inputSize="sm"
                error={(isSubmitted && errors.state_dependent) || {}}
                label={'Dependiente'}
                name={'state_dependent'}
                onChange={handleValueChange}
                t={t}
                checked={values.state_dependent}
              />
              <Form.Checkbox
                className="icheckbox_flat-blue"
                // className="text-left input-table"
                inputSize="sm"
                error={(isSubmitted && errors.unique) || {}}
                label={textoUnico()}
                name={'unique'}
                onChange={handleValueChange}
                t={t}
                checked={values.unique}
              />
              {values.state_dependent ? (
                <Form.FieldSelect
                  error={(isSubmitted && errors.dependent) || {}}
                  name={'dependent'} //Nombre de como se guardara el Custom field
                  label={'Custom Dependiente'}
                  handleChange={handleDependentChange}
                  value={getIdDependent(values.dependent)}
                >
                  {dropDowns.map(
                    //Mapear las opciones del select
                    (option, index) => (
                      <option value={option.id}>{option.key}</option>
                    )
                  )}
                </Form.FieldSelect>
              ) : null}

              <ElementsCustomFieldsForm
                errors={errors}
                values={values}
                handleAddCustomField={handleAddCustomField}
                handleRemoveCustomField={handleRemoveCustomField}
                handleValueChange={handleValueChange}
                handleDependentChange={handleDependentChange}
                isSubmitted={isSubmitted}
                dependent={depSelect}
                dropDowns={dropDowns}
              />
            </div>
          ) : null}
          {/* Drop Down */}
        </div>
      </div>

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />
        <Form.Link
          to={createRoute(company.id, subcompany.id, `custom_fields_employees`)}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    key: {
      type: 'string',
      minLength: 1,
    },
    name: {
      type: 'string',
      minLength: 1,
    },
    elements: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            minLength: 1,
          },
          value: {
            type: 'string',
            minLength: 1,
          },
        },
        required: ['key', 'value'],
      },
    },
  },
  required: ['key', 'name'],
})(translate()(EmployeeForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/components/form/EmployeeForm.js